import { useApi } from "@/composables/useApi";
import { Config } from "@/config";

export const useApiGetApeCategories = useApi(() => ({
  method: "GET",
  url: "/constructor/apes-traits-categories",
  baseURL: Config.apeStorageUrl,
}));
